import { createAction } from "@reduxjs/toolkit";

export const resetStates = createAction("RESET_STATES");
